import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import Notification from "./Notification";
import api from "../Api";

function LogoutButton() {
  const { logoutUser: clearUser } = useUser();
  const [notification, setNotification] = useState({
    message: "",
    type: "success",
  });
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await api.post("/auth/logout");

      Object.keys(localStorage).forEach((key) => {
        if (!key.startsWith("crmdashboard_tour_")) {
          localStorage.removeItem(key);
        }
      });
      clearUser();

      setNotification({ message: "Logout successful!", type: "success" });

      setTimeout(() => {
        navigate("/", {
          replace: true,
          state: { logoutSuccess: true },
        });
      }, 1500);
    } catch (err) {
      console.error(err);
      setNotification({ message: "Logout failed!", type: "error" });
    }
  };

  return (
    <>
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: "", type: "success" })}
      />

      <button className="dropdown-item" onClick={handleLogout}>
        <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
        <span className="align-middle">Logout</span>
      </button>
    </>
  );
}

export default LogoutButton;
